export default [ // DO NOT add `id` field here
  { name: 'Task 1', completed: false },
  { name: 'Task 2', completed: false },
  { name: 'Task 3', completed: false },
  { name: 'Task 4', completed: true },
  { name: 'Task 5', completed: false },
];



// WEBPACK FOOTER //
// ./src/todos.js